const translations = {
  // === NAVBAR & MENU ===
  'nav.beranda': 'Home',
  'nav.tentangKami': 'About Us',
  'nav.portofolio': 'Portfolio',
  'nav.news': 'News',
  'nav.karir': 'Career',
  'nav.kontak': 'Contact',
  'nav.hubungiKami': 'Contact Us',
  'nav.beranda2': 'Home',

  // === HERO SECTION ===
  'hero.label': 'PT Waringin Mega Mandiri — Established Since 2022',
  'hero.title1': 'Building',
  'hero.title2': 'Trusted',
  'hero.title3': 'Contractor',
  'hero.subtitle': 'PT Waringin Mega Mandiri is a subsidiary of Waringin Group and has built shophouses, factories, warehouses, hotels, apartments, restaurants, schools, offices, high-rise buildings, residential houses to industrial estates.',
  'hero.lihatPortofolio': 'View Portfolio',
  'hero.hubungiKami': 'Contact Us',
  'hero.scroll': 'Scroll',
  'hero.stat.tahunPengalaman': 'Years Experience',
  'hero.stat.proyekSelesai': 'Projects Completed',
  'hero.stat.kepuasanKlien': 'Client Satisfaction',
  'hero.stat.klienKorporat': 'Corporate Clients',
  'hero.slogan': 'BUILD TO PERFECTION',

  // === SERVICES (LAYANAN) ===
  'services.label': 'What We Do',
  'services.titleHighlight': 'Our',
  'services.titleSuffix': 'Services',
  'services.subtitle': 'We provide comprehensive construction solutions with leading technology to meet every project requirement.',
  'services.lingkupPekerjaan': 'Scope of Work',
  'services.lingkupSubtitle': 'Construction fields we handle professionally',
  'services.keunggulan': 'Our Advantages',
  'services.mengapaWMM': 'Why Choose',
  'services.dukunganDesc': 'We come with full support from PT. Waringin Megah to ensure every project runs optimally.',
  
  'service.gc.title': 'General Contractor',
  'service.gc.tagline': 'Professional & Trusted Construction Solutions',
  'service.gc.description': 'PT. Waringin Mega Mandiri serves as a professional General Contractor experienced in medium to large-scale construction projects.',
  'service.gc.scope1.title': 'Commercial & Office Buildings',
  'service.gc.scope1.desc': 'Construction of commercial buildings, offices, and shopping centers with international construction standards.',
  'service.gc.scope2.title': 'Residential & Housing',
  'service.gc.scope2.desc': 'Construction of premium residences, apartments, and housing with best materials and precision workmanship.',
  'service.gc.scope3.title': 'Public Facilities & Institutions',
  'service.gc.scope3.desc': 'Development of public facilities, hospitals, schools, and government buildings.',
  'service.gc.scope4.title': 'Special & Mixed-Use Projects',
  'service.gc.scope4.desc': 'Handling highly complex projects, including mixed-use developments.',
  'service.gc.why1': 'Experienced Team from PT. Waringin Megah',
  'service.gc.why2': 'Structured & Transparent Project Management',
  'service.gc.why3': 'Commitment to Quality & On-Time Delivery',
  'service.gc.why4': 'Full Support in Manpower, Equipment & Finance',
  'service.gc.why5': 'Proven Project Track Record',
  'service.gc.why6': 'Active Client Communication',
  'service.gc.stat1.val': '50+',
  'service.gc.stat1.label': 'Projects Completed',
  'service.gc.stat2.val': '100%',
  'service.gc.stat2.label': 'Client Satisfaction',
  'service.gc.stat3.val': '2022',
  'service.gc.stat3.label': 'Year Founded',
  'service.gc.cta': 'Project Consultation',
  'service.6.title': 'Service & Maintenance',

  // === TENTANG KAMI (ABOUT PAGE) ===
  'about.title': 'About Us',
  'about.subtitle': 'Get to know PT Waringin Mega Mandiri — a construction company building Indonesia with technology and integrity.',
  'about.breadcrumb': 'About Us',
  'about.beranda': 'Home',
  'about.fondasi': 'Our Foundation',
  'about.nilaiPerusahaan': 'Company Values',
  'about.perjalanan': 'Our Journey',
  'about.historyMilestone': 'History & Milestone',

  // === VISI & MISI ===
  'vm.label': 'Direction & Purpose',
  'vm.title': 'Vision &',
  'vm.highlight': 'Mission',
  'vm.visi': 'Vision',
  'vm.misi': 'Mission',
  'vm.visiQuote': 'To become a trusted construction services company that delivers high-quality products and provides the best service for customer satisfaction.',
  'vm.misi1': 'To realize high-quality construction service products with competitive prices.',
  'vm.misi2': 'To carry out comprehensive sustainable development in all aspects that support the company.',
  'vm.misi3': 'To provide the best service to customers.',

  // === PROFIL PERUSAHAAN ===
  'profile.label': 'Company Profile',
  'profile.title': 'PT Waringin',
  'profile.highlight': 'Mega Mandiri',
  'profile.founded': 'Founded',
  'profile.p1': 'PT. Waringin Mega Mandiri is a construction services/General Contractor company which is a subsidiary of PT. Waringin Megah located in Jakarta.',
  'profile.p2': 'Founded in 2022 to manage projects previously managed by the PT. Waringin Megah Management Team, Jakarta division.',
  'profile.p3': 'The management team is always determined to serve and satisfy all customers with the best quality work.',
  'profile.kota': 'Operating in Jakarta',
  'profile.tenaga': 'Experienced Professional Team',
  'profile.proyek': 'High Quality Projects',
  'profile.standar': 'Supported by PT. Waringin Megah',

  // === NILAI PERUSAHAAN (VALUES) ===
  'values.label': 'Our Foundation',
  'values.title': 'Company',
  'values.highlight': 'Values',
  'value.1.title': 'Integrity',
  'value.1.desc': 'We uphold honesty and transparency in every aspect of our business and project execution.',
  'value.2.title': 'Quality',
  'value.2.desc': 'ISO 9001 premium quality standards are applied in every construction process.',
  'value.3.title': 'Innovation',
  'value.3.desc': 'Continuously innovating with the latest BIM technology, drone survey, and AI in project management.',
  'value.4.title': 'Collaboration',
  'value.4.desc': 'Building mutually beneficial strategic partnerships with clients and partners.',

  // === PORTOFOLIO ===
  'portfolio.title': 'Project Portfolio',
  'portfolio.subtitle': 'Our track record in building various prestigious construction projects across Indonesia.',
  'portfolio.breadcrumb': 'Portfolio',
  'portfolio.semua': 'All',
  'portfolio.gedung': 'Building',
  'portfolio.infrastruktur': 'Infrastructure',
  'portfolio.renovasi': 'Renovation',
  'portfolio.industrial': 'Industrial',
  'portfolio.statusSelesai': 'Completed',
  'portfolio.statusOngoing': 'Ongoing',
  'portfolio.menampilkan': 'Showing',
  'portfolio.proyek': 'projects',
  'portfolio.dalamKategori': 'in category',
  'portfolio.konsultasiCta': 'Interested in working with us? Consult your construction needs now.',
  'portfolio.konsultasiBtn': 'Consult Your Project',
  'portfolio.tidakAda': 'No projects in this category.',

  // === KARIR ===
  'karir.badge': 'Join Our Team',
  'karir.title1': 'Build Your Career at',
  'karir.title2': 'PT Waringin Mega Mandiri',
  'karir.subtitle': 'Join our professional team and become part of the best construction projects in Indonesia.',
  'karir.mengapa': 'Why Join WMM?',
  'karir.komunitas': 'We are a professional community that grows together.',
  'karir.lowongan': 'Open Positions',
  'karir.posisiTerbuka': 'open positions — find the one that matches your expertise',
  'karir.semua': 'All',
  'karir.tidakAda': 'No openings at the moment.',
  'karir.tidakCocok': 'Didn\'t Find a Suitable Position?',
  'karir.kirimSpontan': 'Send your CV spontaneously to our email.',
  'karir.kirimBtn': 'Send Spontaneous Application',
  'karir.deskripsiPekerjaan': 'Job Description',
  'karir.keuntungan': 'Benefits & Perks',
  'karir.kualifikasi': 'Qualifications & Requirements',
  'karir.lamarSekarang': 'Apply Now',
  'karir.tanyaWA': 'Ask via WhatsApp',
  'karir.deadline': 'Deadline',
  'karir.dept.manajemen': 'Project Management',
  'karir.dept.teknologi': 'Technology & Innovation',
  'karir.dept.engineering': 'Engineering',
  'karir.dept.estimasi': 'Estimation & Cost',
  'karir.dept.hse': 'Health, Safety & Environment',
  'karir.dept.desain': 'Design & Drafting',

  // === NEWS / BERITA ===
  'news.badge': 'News & Insights',
  'news.title1': 'News &',
  'news.title2': 'Updates',
  'news.subtitle': 'Latest information about projects, construction technology, and developments of PT Waringin Mega Mandiri.',
  'news.artikelPilihan': 'Featured Articles',
  'news.semua': 'All',
  'news.artikel': 'articles',
  'news.tidakAda': 'No articles in this category.',
  'news.newsletterTitle': 'Subscribe to Newsletter',
  'news.newsletterSubtitle': 'Get the latest WMM project news and updates directly in your inbox.',
  'news.placeholder': 'email@example.com',
  'news.subscribe': 'Subscribe',
  'news.subscribed': 'Successfully subscribed!',
  'news.bacaSelengkapnya': 'Read more',

  // === TIM MANAJEMEN ===
  'team.label': 'Our Leaders',
  'team.title': 'Management',
  'team.highlight': 'Team',
  'team.subtitle': 'Led by experienced professionals with a track record of national and international scale projects.',
  'team.pendiri': 'Company Founders',
  'team.direksi': 'Board of Directors',
  'team.orang': 'people',
  'team.pos.pemegang': 'Shareholder',
  'team.pos.komisaris': 'President Commissioner',
  'team.pos.direktur': 'President Director',
  'team.desc.1': 'Developer based in Surabaya. Founded PT. Waringin Megah in 1987 with Ir. Yohanes Sucipto.',
  'team.desc.2': 'Graduate of Civil Engineering, Petra Christian University, 1985. Founded PT. Waringin Megah.',
  'team.desc.3': 'Civil Engineering graduate of ITS Surabaya, 1989. Now serves as President Commissioner of PT. Waringin Mega Mandiri.',
  'team.desc.4': 'Civil Engineering graduate of Maranatha University Bandung, 1994. Now serves as President Director of PT. Waringin Mega Mandiri.',

  // === KONTAK & FORM ===
  'kontak.heroBadge': 'Get In Touch',
  'kontak.heroTitle1': 'Let\'s',
  'kontak.heroTitle2': 'Talk',
  'kontak.heroSubtitle': 'We are ready to help bring your dream project to life. Free consultation, fast response.',
  'kontak.infoTitle': 'Contact Information',
  'kontak.infoSubtitle': 'Reach us through various available communication channels.',
  'kontak.address': 'Office Address',
  'kontak.addressVal': 'Jl. Bendungan Hilir Raya G1 No.5 Central Jakarta 10210',
  'kontak.addressSub': 'View on Google Maps',
  'kontak.phone': 'Phone',
  'kontak.phoneVal': '+62 21 5738001',
  'kontak.phoneSub': 'Mon – Sat, 08.00–17.00 WIB',
  'kontak.email': 'Email',
  'kontak.emailVal': 'info@waringinmegamandiri.com',
  'kontak.emailSub': 'Response within 1×24 business hours',
  'kontak.whatsapp': 'WhatsApp',
  'kontak.whatsappVal': '+62 812-3456-7890',
  'kontak.hours': 'Operating Hours',
  'kontak.weekdays': 'Mon – Fri',
  'kontak.weekdaysHours': '08.00 – 17.00 WIB',
  'kontak.saturday': 'Saturday',
  'kontak.saturdayHours': '08.00 – 13.00 WIB',
  'kontak.sunday': 'Sunday',
  'kontak.sundayHours': 'Closed',
  'kontak.formTitle': 'Send a Message',
  'kontak.formSubtitle': 'Fill in the form below and our team will contact you shortly.',
  'kontak.name': 'Full Name',
  'kontak.namePlaceholder': 'Enter your full name',
  'kontak.emailLabel': 'Email',
  'kontak.emailPlaceholder': 'email@company.com',
  'kontak.phoneLabel': 'Phone Number',
  'kontak.phonePlaceholder': '+62 8xx-xxxx-xxxx',
  'kontak.company': 'Company / Institution',
  'kontak.companyPlaceholder': 'Your company name (optional)',
  'kontak.projectType': 'Project Type',
  'kontak.projectTypePlaceholder': 'Select project type',
  'kontak.budget': 'Estimated Budget',
  'kontak.budgetPlaceholder': 'Select budget range',
  'kontak.message': 'Message / Project Description',
  'kontak.messagePlaceholder': 'Briefly describe your project needs...',
  'kontak.submit': 'Send Message',
  'kontak.submitting': 'Sending...',
  'kontak.successTitle': 'Message Sent!',
  'kontak.successMsg': 'Thank you! Our team will contact you within 1x24 business hours.',
  'kontak.mapTitle': 'Our Location',
  'kontak.ctaTitle': 'Or Contact Directly via WhatsApp',
  'kontak.ctaSubtitle': 'Get a faster response through WhatsApp.',
  'kontak.ctaBtn': 'Chat via WhatsApp',
  'kontak.required': 'Required',
  'kontak.charLimit': 'Max 500 characters',
  'kontak.sertifikasi': 'Certifications & Legality',
  'kontak.socialMedia': 'Social Media',
  'kontak.kembali': 'Back',

  // === FOOTER ===
  'footer.perusahaan': 'COMPANY',
  'footer.layanan': 'SERVICES',
  'footer.kontak': 'CONTACT',
  'footer.desc': 'Construction Services/General Contractor subsidiary of PT. Waringin Megah, committed to serving customers with best results.',
  'footer.copyright': '© 2024 PT Waringin Mega Mandiri. All Rights Reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',

  // === PROJECT CARD & MODAL ===
  'project.lihatDetail': 'View Details',
  'project.lokasi': 'Location',
  'project.tahun': 'Year',
  'project.klien': 'Client',
  'project.nilai': 'Value',
  'project.kategori': 'Category',
  'project.status': 'Status',
  'project.diskusi': 'Discuss Similar Project',
  'project.tutup': 'Close',
  'project.statusSelesai': 'Completed',
  'project.statusOngoing': 'Ongoing',
  'project.tahunLabel': 'Year',
  'project.tipeBangunan': 'Building Type',
  'project.paketPekerjaan': 'Work Package',
  'project.lantai': 'Floors',
  'project.luasBangunan': 'Building Area',
  'project.jumlahUnit': 'Unit Count',
  'project.prevPhoto': 'Previous photo',
  'project.nextPhoto': 'Next photo',
  'featured.showcase': 'Ongoing Projects',
  'featured.proyek': 'Project',
  'featured.unggulan': 'Ongoing',
  'featured.lihatSemua': 'View All Projects',
  'featured.detailProyek': 'Project Details',
  'featured.selesai': 'Completed',

  // === LAIN-LAIN / BADGES ===
  'badge.lpjk': 'LPJK Certified',
  'badge.iso': 'ISO 9001:2015',
  'badge.sbu': 'SBU Certified',
  'sbu.41011': '41011 – Residential Building',
  'sbu.41012': '41012 – Office Building',
  'sbu.41013': '41013 – Industrial Building',
  'sbu.41014': '41014 – Commercial Building',
  'sbu.41015': '41015 – Healthcare Building',
  'sbu.41017': '41017 – Hospitality Building',
  'sbu.41019': '41019 – Place of Worship',
};

export default translations;